<template>
    <div class="custom-control custom-checkbox">
        <input 
            type="checkbox" 
            class="custom-control-input" 
            :id="_uid"
            :value="val"
            v-model="checked"
            @change="onChange">
        <label class="custom-control-label" :for="_uid">
            <slot>{{ label }}</slot>
        </label>
    </div>
</template>

<script>
export default {
    props: ['value', 'label', 'val'],
    data: function() {
        return {
            checked: this.value.slice()
        }
    },
    watch: {
        value: function(value) {
            this.checked = value.slice();
        }
    },
    methods: {
        onChange: function() {
            this.$emit('input', this.checked);
        }
    }
}
</script>